import { Icon } from "@chakra-ui/react";
import { LuTriangleAlert } from "react-icons/lu";

import { useColorModeValue } from "../../../components/ui/color-mode";

const ErrorIcon = () => {
  const color = useColorModeValue("red.500", "red.300");

  return (
    <Icon boxSize={16} color={color} asChild>
      <LuTriangleAlert />
    </Icon>
  );
};

export { ErrorIcon };
